---
fr:
  event_mapping:
    destroy_warning: Cela supprimera tous les mappages d'événements précédents pour cette éolienne, êtes-vous sûr de vouloir continuer ?
    file_too_large: Le fichier est trop volumineux
    import: Importer l'attribution des évenements
    invalid_file: Le fichier n'a pas pu être lu. Il est peut-être corrompu ou dans un format incorrect.
    no_file_selected: Aucun fichier sélectionné
    title: Attribution des événements
    xlsx_file_input: Fichier XLSX à télécharger
